(() => {
  const PROPERTY_KEY = 'Thanksカード用のお名前 or ニックネーム（ローマ字入力）';

  // Dawn等のカートドロワーがあれば開く（無ければ /cart に遷移）
  const openCartUI = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    window.location.href = '/cart';
  };

  const getThanksValue = (form) => {
    const el = form.querySelector(`input[name="properties[${CSS.escape(PROPERTY_KEY)}]"]`);
    return (el?.value || '').trim();
  };

  const getVariantId = (form) => {
    const idEl = form.querySelector('input[name="id"]');
    return idEl ? String(idEl.value) : '';
  };

  // “同一variant + 同一Thanks名” が既にあるか判定
  const existsSameLine = async (variantId, thanksValue) => {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();

    return cart.items?.some((item) => {
      const sameVariant = String(item.variant_id) === String(variantId);
      const props = item.properties || {};
      const sameThanks = (props[PROPERTY_KEY] || '').trim() === (thanksValue || '').trim();
      return sameVariant && sameThanks;
    });
  };

  // 追加ボタン（/cart/add）送信を横取り：重複なら止める
  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      // Dawnのproduct form（/cart/add にPOSTするform）だけ対象
      if (!form.action || !form.action.includes('/cart/add')) return;

      const variantId = getVariantId(form);
      if (!variantId) return;

      // quantityを常に1に寄せる（万一UIが残ってても）
      const qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = '1';

      const thanksValue = getThanksValue(form);

      // required なので空の場合はブラウザのバリデーションに任せる
      // （ここで止める必要なし）

      try {
        const duplicated = await existsSameLine(variantId, thanksValue);

        if (duplicated) {
          // ここが“最短で2倍にならない”ポイント：送信を止める
          e.preventDefault();
          e.stopImmediatePropagation();
          openCartUI();
        }
      } catch (err) {
        // 失敗したら通常送信（購入導線を止めない）
        // console.warn(err);
      }
    },
    true // captureで先に拾って、Dawnのproduct-form.jsより前に判定
  );

  // カート側で数量変更されそうなUIが残っている場合の保険（任意）
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.name || !t.name.includes('updates')) return;
    t.value = '1';
  });
})();
